import * as React from 'react';
import { QuantitySelector } from '@grandvisionhq/common';
import { StockIndicator } from '@grandvisionhq/inventory';
import { H2 } from '@grandvisionhq/iris-ui';
import { useIntl } from '@grandvisionhq/state';
import { getCalculatedMaximumQuantity } from '@grandvisionhq/utils';
import '../../../../../context/actions.js';
import '../../../../../context/reducer.js';
import { useProductData } from '../../../../../context/product-context-hooks.js';
import '../../../../../context/ProductContext.js';
import '../../../../../context/CmsContext.js';
import '@grandvisionhq/analytics';
import '@swc/helpers';
import { pushSolutionsChangeQuantityEvent } from '../../../../Analytics/events/change-quantity-events.js';
import '../../../../../types/product.js';
import '@grandvisionhq/svc-tealium/events';
import '@grandvisionhq/graphql';
import '@grandvisionhq/svc-tealium/utils';
import { useSolutionsEcommContext } from '../../context/SolutionsEcommContext.js';

const SolutionsQuantityAndStock = ()=>{
    const { getLabel  } = useIntl();
    const { activeVariant , selectedPurchaseType  } = useProductData();
    const { actions , state , maxOrderableQuantity  } = useSolutionsEcommContext();
    const { channelAvailability , stock  } = activeVariant;
    const { quantity: selectedQuantity  } = state.configurations;
    const maxSelectableQuantity = getCalculatedMaximumQuantity(maxOrderableQuantity, stock.stockCount, stock.isAllowBackOrder);
    const onQuantityChange = (quantity, type)=>{
        actions.updateQuantity(quantity);
        pushSolutionsChangeQuantityEvent({
            quantity,
            quantityChange: type,
            purchaseType: selectedPurchaseType
        });
    };
    const onIncreaseQuantity = ()=>{
        const quantity = selectedQuantity + 1;
        onQuantityChange(quantity, 'increase');
    };
    const onDecreaseQuantity = ()=>{
        const quantity = selectedQuantity - 1;
        onQuantityChange(quantity, 'decrease');
    };
    if (channelAvailability !== 'ONLINE') {
        return null;
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: "solutions-quantity-and-stock"
    }, /*#__PURE__*/ React.createElement(H2, {
        variant: "heading-tiny",
        className: "solutions-quantity-and-stock__label"
    }, getLabel('products.solutions.selectAmount')), /*#__PURE__*/ React.createElement("div", {
        className: "solutions-quantity-and-stock__wrapper"
    }, /*#__PURE__*/ React.createElement(QuantitySelector, {
        quantity: selectedQuantity || 1,
        minimumQuantity: 1,
        maximumQuantity: maxSelectableQuantity,
        onDecreaseQuantity: onDecreaseQuantity,
        onIncreaseQuantity: onIncreaseQuantity
    }), /*#__PURE__*/ React.createElement(StockIndicator, {
        stockCount: stock.stockCount,
        allowBackOrder: stock.isAllowBackOrder,
        channelAvailability: channelAvailability
    })));
};

export { SolutionsQuantityAndStock };
//# sourceMappingURL=SolutionsQuantityAndStock.js.map
